import logo from '../resources/logo.png'
import {FaFacebookMessenger} from 'react-icons/fa'
import {AiFillAndroid} from 'react-icons/ai'

const PrivacyHeader = () => {

	return (
		<header className="privacy-header">
			<a href="/" className="resultspage-header-a">
            	<img className="resultspage-logo" src={logo} alt="logo"/>
            	<span className="resultspage-logo-text">Trivtionary</span>
            </a>
	        <div className="resultspage-a-cont">
				<a href="https://joepet-ryan-quimora.itch.io/trivtionary" className="resultspage-header-a-side">Messenger Bot</a>
	            <a href="https://m.me/trivtionary" className="resultspage-header-a-side">Messenger Bot</a>
                <a href="/https://m.me/trivtionary" className="resultspage-header-a-side-mobile"><FaFacebookMessenger size={25} /></a>
                <a href="https://joepet-ryan-quimora.itch.io/trivtionary" className="resultspage-header-a-side-mobile"><AiFillAndroid size={25} /></a>
            </div>
		</header>
	)

}

export default PrivacyHeader